module.exports = __webpack_public_path__ + "static/media/cauldron.49844111.PNG";